import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            TALEO & Recruitment Details\n          ")
], -1);
const _hoisted_5 = { class: "col-span-6 mt-4" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "offer_stage",
    class: "block text-sm font-medium text-gray-700"
}, "TALEO Vacancy ID: *", -1);
const _hoisted_7 = ["value", "disabled"];
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = { key: 0 };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-blue-700" }, "The hiring manager has specified that they would like the role to be advertised, please provide the following details:", -1);
const _hoisted_11 = { class: "col-span-6 mt-4" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", {
    for: "offer_stage",
    class: "block text-sm font-medium text-gray-700"
}, "URL link to advert: *", -1);
const _hoisted_13 = ["value", "disabled"];
const _hoisted_14 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_15 = { class: "col-span-6 mt-4" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", {
    for: "offer_stage",
    class: "block text-sm font-medium text-gray-700"
}, "Advert close date: *", -1);
const _hoisted_17 = ["value", "disabled"];
const _hoisted_18 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_19 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_20 = ["disabled"];
const _hoisted_21 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(),
                    _createElementVNode("input", {
                        id: "taleo_vacancy_id-input",
                        value: _ctx.data?.resourcing?.taleo_vacancy_id,
                        type: "text",
                        name: "taleo_vacancy_id",
                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                        disabled: _ctx.disableForm,
                        onInput: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                        onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.data.resourcing.taleo_vacancy_id.$touch()))
                    }, null, 42, _hoisted_7),
                    _createTextVNode(),
                    (_ctx.v$.data?.resourcing?.taleo_vacancy_id.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n                * " + _toDisplayString(_ctx.v$.data?.resourcing?.taleo_vacancy_id.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                (_ctx.data?.formSeven?.recruitmentTeam !== 'No')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "url_link-input",
                                value: _ctx.data?.resourcing?.url_link,
                                type: "text",
                                name: "url_link",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                disabled: _ctx.disableForm,
                                onInput: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.data?.resourcing.url_link.$touch()))
                            }, null, 42, _hoisted_13),
                            _createTextVNode(),
                            (_ctx.v$.data?.resourcing?.url_link.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "\n                  * " + _toDisplayString(_ctx.v$.data?.resourcing?.url_link.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "advert_close-input",
                                value: _ctx.data?.resourcing?.advert_close,
                                type: "date",
                                name: "advert_close",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                disabled: _ctx.disableForm,
                                onInput: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.data?.resourcing.advert_close.$touch()))
                            }, null, 42, _hoisted_17),
                            _createTextVNode(),
                            (_ctx.v$.data?.resourcing?.advert_close.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "\n                  * " + _toDisplayString(_ctx.v$.data?.resourcing?.advert_close.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _createTextVNode(),
            (_ctx.profile?.RESOURCING && !_ctx.disableForm && _ctx.data.currentStageName === 'starter.notifyRecruitmentUpdated')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.saveForLater && _ctx.saveForLater(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_20),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "ml-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                    }, "\n          Complete\n        ", 8, _hoisted_21)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
